import * as React from "react";
import {Component} from "react";
import styles from "../../styles/wizards/superadmin/AddPaperSizeWizard.scss";
import autobind from "autobind-decorator";
import AddPaperSizeIcon from "../../assets/images/add-paper-size-64x64.svg";
import {mapStateToProps, setTableParams, validateForm} from "../../core/utils";
import {withRouter} from "react-router";
import {setNotification} from "../../redux/actions/general/notification";
import {createPaperSize, listPaperSizes} from "../../redux/actions/table/superadmin/paper_sizes";
import AddPaperSizeForm from "../../forms/superadmin/add_paper_size_wizard/AddPaperSizeForm";
import * as _ from "lodash";

@withRouter
@mapStateToProps(state => ({
    table: state.table["superadmin_paper_sizes"],
}))
class AddPaperSizeWizard extends Component {
    @autobind
    _handleSubmit(formData) {
        const {edit} = formData;
        
        return validateForm(
            createPaperSize(formData).then(({response}) => {
                listPaperSizes().then(() => {
                    if(edit) {
                        setTableParams('superadmin_paper_sizes', {
                            clicked_row: response.data.id
                        });
                    }
                });

                setTableParams('superadmin_paper_sizes', {
                    actioned_row: undefined,
                    selected_rows: []
                });

                this.props.onClose();

                setNotification("You have successfully added a new paper size.");
            })
        );
    }

    render() {
        return (
            <>
                <div className={styles.header}>
                    <div className={styles.left}>
                        <span>Add paper size</span>
                        <span>Add paper size to the application</span>
                    </div>
                    <div className={styles.right}>
                        <AddPaperSizeIcon />
                    </div>
                </div>
                <div className={styles.body}>
                    <AddPaperSizeForm onSubmit={this._handleSubmit} />
                </div>
            </>
        );
    }
}

export default AddPaperSizeWizard;